import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseWidget } from '../base-widget/base-widget';

@Component({
  selector: 'explore-other-categories',
  // standalone: true,
  // imports: [CommonModule],
  templateUrl: './explore-other-categories.component.html',
  styleUrl: './explore-other-categories.component.scss',
  standalone: true,
  imports: [CommonModule],
})
export class ExploreOtherCategoriesComponent extends BaseWidget {
  @HostBinding('class') @Input() ngClass: any;
  @HostBinding('style') @Input() ngStyle: any;

  @Input() actionEvent: (event: any) => void;
  @Input() slot: any;
}
